module.exports = __webpack_public_path__ + "img/f5473c8.jpg";